import { DAYS_THRESHOLD } from './constants';

//проверяет прошло ли 7 дней
export const getLocalStorageFiltersIsExpired = (key: string) => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const existing = localStorage.getItem(key);

    if (!existing) {
      return false;
    }

    const dateFirstClick = JSON.parse(existing).date;
    const threshold = DAYS_THRESHOLD * 24 * 60 * 60 * 1000;
    const today = Date.now();

    const isExpired = today - dateFirstClick >= threshold;

    return isExpired;
  } catch (er) {
    console.error('Error working with localStorage', er);

    return false;
  }
};

//проверяет что фильтры были применены 2 раза
export const getLocalStorageFiltersWereAppliedTwoTimes = (key: string) => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const existing = localStorage.getItem(key);

    return existing ? JSON.parse(existing).isSecondClick : false;
  } catch (er) {
    console.error('Error working with localStorage', er);

    return false;
  }
};

//удаляем значение
export const removeLocalStorageFiltersWereApplied = (key: string) => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

//проверяем был ли показан опрос для uxfb
export const getLocalStorageFiltersPollWasShow = (key: string) => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const existing = localStorage.getItem(key);

    return existing ? JSON.parse(existing).isShown : false;
  } catch (er) {
    console.error('Error working with localStorage', er);

    return false;
  }
};

//устанавливает показ опроса для uxfb
export const setLocalStorageFiltersPollWasShow = (key: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const existing = localStorage.getItem(key);

    if (!existing) {
      return;
    }

    const value = { ...JSON.parse(existing), isShown: true };

    localStorage.setItem(key, JSON.stringify(value));
  } catch (er) {
    console.error('Error working with localStorage', er);
  }
};
